import { Component, Input, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-preloader',
    templateUrl: './preloader.component.html',
    styleUrls: ['./preloader.component.scss']
})

@Injectable({
    providedIn: 'root'
})

export class PreloaderComponent {
    constructor( @Inject(DOCUMENT) private document: Document ) { }
    @Input() miniPreloader: boolean = false;
    @Input() disableSpinning: boolean = false;
    @Input() incomingText: string = "";
    @Input() imageSrc: string = "Content/Images/icons/preloader.png";
    defaultText:boolean = true;
    text: any;

    ngAfterViewInit() {
        this.defaultText = this.incomingText?.length === 0 ?? true;
        const portalLoadingText = document.querySelector("#portalLoadingText");
        if (portalLoadingText) {
          const value = portalLoadingText.getAttribute("value");
          this.text = value;
        }
    }
}
